import { useEffect, useState } from 'react';
import UserList from '@src/cache/UserList';
import UserInfoDTO from '@src/adapters/dto/user/UserInfoDTO';

interface Props {
  id: string;
  firstNameFirst?: boolean;
}

function UserName({ id, firstNameFirst }: Props) {
  const { getList: getUsers } = UserList();
  const [display, setDisplay] = useState('');

  useEffect(() => {
    if (id) {
      getUsers(id).then((uis: UserInfoDTO[]) => {
        const user = uis.find((u) => u.id === id);

        if (user) {
          if (firstNameFirst) {
            setDisplay(
              [user.firstName, user.lastName].filter(Boolean).join(' ')
            );
          } else {
            setDisplay(
              [user.lastName, user.firstName].filter(Boolean).join(' ')
            );
          }
        } else {
          setDisplay(id);
        }
      });
    } else {
      setDisplay('');
    }
  }, [firstNameFirst, getUsers, id]);

  return <span>{display}</span>;
}

export default UserName;
